import Link from 'next/link'

import { ROUTE_PRIVACY_POLICY } from '@/res/routes'
import { ISelectOption } from '@/types/Common'

interface Props {
  privacyResults: ISelectOption[]
  id?: number
}

const PrivacySidebar: React.FC<Props> = ({ privacyResults, id }) => {
  return (
    <>
      <aside className="bg-white w-full min-h-[50px] md:w-[200px]">
        <ul className="fixed">
          {privacyResults.map((p) => {
            const isActive = p.id === Number(id)
            return (
              <li
                key={p.id}
                className={`${
                  isActive
                    ? 'pl-[5px] mb-[15px] font-bold text-sky-800 border-sky-800 border-l-[2px]'
                    : 'pl-[5px] mb-[15px] text-black transition  duration-150 hover:border-l-[2px] hover:border-sky-800 hover:font-bold hover:text-sky-800'
                }`}
              >
                <Link href={`${ROUTE_PRIVACY_POLICY}/${p.id}`}>
                  <a>{p.name}</a>
                </Link>
              </li>
            )
          })}
        </ul>
      </aside>
    </>
  )
}
export default PrivacySidebar
